export default __webpack_public_path__ + "static/media/2094-01.74fafc0e.jpg";